import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import AppContentMenuFooter from "../AppContentMenuFooter";
import AppContentMenuHeader from "../AppContentMenuHeader";
import AppContentMenuList from "../AppContentMenuList";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
`;

export interface IProps {
  closeMenu: () => void;
}

export default class AppContentMenu extends PureComponent<IProps> {
  public render(): ReactNode {
    const { closeMenu } = this.props;

    return (
      <Wrapper>
        <AppContentMenuHeader closeMenu={closeMenu} />
        <AppContentMenuList closeMenu={closeMenu} />
        <AppContentMenuFooter closeMenu={closeMenu} />
      </Wrapper>
    );
  }
}
